<template>
  <div class="home">
    <div v-for="item in Generators" :key="item.key">
      <router-link :to="{ name: 'Generator', params: { generator: item.key }}"><h1>{{item.title}} Generator</h1></router-link>
      <section>
        {{item.description}}
      </section>
    </div>
  </div>
</template>

<script>
// @ is an alias to /src
import Generators from '@/store/generators'

export default {
  name: 'Home',
  data: () => {
    return {
      Generators
    }
  }
}
</script>
